import { toast } from 'sonner';

export { toast };

export function getErrorMessage(err, fallback = 'Something went wrong') {
  const msg =
    err?.response?.data?.error ||
    err?.response?.data?.message ||
    err?.message ||
    (typeof err === 'string' ? err : null);
  return (msg && String(msg)) || fallback;
}

export function toastSuccess(message) {
  toast.success(message);
}

export function toastError(err, fallback) {
  toast.error(getErrorMessage(err, fallback));
}

export function confirmToast({
  title = 'Are you sure?',
  description,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  confirmVariant = 'danger',
} = {}) {
  return new Promise((resolve) => {
    const id = toast(title, {
      description,
      action: {
        label: confirmLabel,
        onClick: () => {
          toast.dismiss(id);
          resolve(true);
        },
      },
      cancel: {
        label: cancelLabel,
        onClick: () => {
          toast.dismiss(id);
          resolve(false);
        },
      },
      duration: 8000,
      className: confirmVariant === 'danger' ? 'tv-toast-danger' : undefined,
    });
  });
}

